module.exports = __webpack_public_path__ + "static/media/belcolor__8.bae4627e.jpg";